import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { DynamicEvent } from 'src/app/main/dynamic/dynamic.event';

@Component({
  selector: 'app-boolean',
  templateUrl: './boolean.component.html',
  styleUrls: ['./boolean.component.scss']
})
export class BooleanComponent extends ComponentBase implements OnInit {
  
  constructor() {
    super();
  }

  
  get value(): boolean
  {
    if(this.attribute.value) {
      return this.attribute.value.toLowerCase() == "true";
    } else {
      return false;
    }
  }

  set value(checked: boolean)
  {
      this.attribute.value = String(checked)
  }

  ngOnInit() {
  }

  onValueChange(value: boolean) {
    this.attribute.value = value.toString();

    let events: DynamicEvent[] = []

    events.push({ attribute: {
      value: `${value}`,
      key: this.attribute.key,
      type: this.attribute.type
    }});

    events.push({ name: "autosave", data: "silently" })

    this.emitEvents(events)
  }
}
